const initialState = {
    response: "",
    welcomeMessage: "",
    isVisible: 0,
    welcomeMessageSuccess: false,
}

const participant = (state = initialState, action) => {
    switch (action.type) {
        case "DEMOGRAPHICS_DATA":
            return {
                ...state,
                demographicsData : action.result,
            }
        case "SET_PID":
            return {
                ...state,
                userPID: action.PID
            }
        case "SET_WELCOME_MESSAGE":
            return {
                ...state,
                welcomeMessage: action.payload
            };
        case "SET_WELCOME_VISIBILITY":
            return {
                ...state,
                isVisible: action.payload,
            };
        case "SET_WELCOME_MESSAGE_SUCCESS":
            return {
                ...state,
                welcomeMessageSuccess: action.payload,
            };
        default:
            return state;
    }

};
export default participant;